import React,{useState} from 'react';
import styled from "styled-components";
import usePopups from '../../Hooks/usePopups';
import CancelIcon from '@material-ui/icons/Cancel';

const Modal=styled.div`
background-color: rgba(0, 0, 0, 0.5);
position:fixed;
width:100vw;
height:100vh;
z-index:2;`;

const Container=styled.div`
display:flex;
position:fixed;
justify-content:center;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);`;

const ImagenStyled=styled.img`
width:25vw; 

@media only screen and (max-width: 780px) 
{
    width:75vw; 
}`;

const Popup=({popup})=>
{
    const [OpenModal, setOpenModal] = useState(true);
    const {id,data}=popup;
    const {Imagen}=data;

    const CloseModal=()=>
    {
        const style={color:"white",cursor:"pointer",fontSize:"35px",marginLeft:"-15px",marginTop:"-15px"}

        const Close=()=>
        {
            setOpenModal(false);
        }

        return <CancelIcon style={style} onClick={Close}>X</CancelIcon>
    }
   
    if(OpenModal)
    {
      
        return <Modal key={id}>
            <Container>
                <ImagenStyled alt={id} src={Imagen}/>
                <CloseModal/>
            </Container>
        </Modal>
    }
    else
    {
        return "";
    }
}

const Popups = () => 
{
    const PopUps= usePopups();
    

    return <div>
        {PopUps.map(popup =>
        {
            if(popup.data.Activo){
                return <Popup popup={popup} key={popup.id}/>
            }
        })}
    </div>
}

export default Popups
